import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 21.875rem;
  color: var(--ds-text-lowEmphasis, #6b778c);
  gap: 0.625rem;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  width: 13.125rem;
  border-radius: 0.1875rem;
  border: 0.0625rem solid #ccc;
  background: white;
  padding: 0;
`;

export const ListItem = styled.button`
  width: 100%;
  padding: 0.625rem;
  cursor: pointer;
  border: none;
  text-align: left;
  background: white;
  border-bottom: 0.0625rem solid #ccc;

  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;

  &:last-child {
    border-bottom: none;
  }

  &:hover,
  &:focus {
    background: #f0f0f0;
  }

  &.customizar {
    color: rgb(51, 153, 255);
    font-weight: bold;
    text-align: left;
    position: sticky;
    bottom: 0;
    background: #fff;
    border-top: 1px solid #ccc;
    z-index: 5;
  }
`;
